import dayjs from "dayjs";

export const dateFormat = (date) => {
  return dayjs(date * 1000).format("DD.MM.YY");
};
